import React from 'react'
import { useParams } from 'react-router-dom';
import Workflow from './Workflows';


function WorkflowPage() {
  var params = useParams();
  var { groupId } = params;
  return (
    <div className="main-content">
    <Workflow groupId={groupId} searchIcon={true} />
    </div>
  )
}

export default WorkflowPage